import styled from 'styled-components'
import { Link } from 'react-router-dom'

const activeStyles = `
  background-color: #fff;
  color: #000;
`

const inactiveStyles = `
  background-color: transparent;
  color: #fff;

  &:hover {
    background-color: rgba(255, 255, 255, 0.12);
  }
`

export const NavigationContainer = styled.nav`
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
  height: 100%;
  padding-left: 5px;
`

export const NavLink = styled(Link)<{ isActive?: boolean }>`
  display: flex;
  align-items: center;
  text-decoration: none;
  font-size: 15px;
  padding: 8px 18px;
  border-radius: 8px;
  white-space: nowrap;
  background-color: #fff;
  color: #000;
`

export const ExternalNavLink = styled.a`
  display: flex;
  align-items: center;
  text-decoration: none;
  font-size: 15px;
  padding: 8px 18px;
  border-radius: 8px;
  white-space: nowrap;
  cursor: pointer;
  background-color: transparent;
  color: #fff;
  transition:
    background-color 0.2s,
    color 0.2s;

  &:hover {
    background-color: rgba(255, 255, 255, 0.12);
  }
`
